<form #form="ngForm" class="form form-full-width">
    <div class="table-container margin-top-medium">
        <table>
            <thead>
                <tr>
                    <th colspan="3">
                        Teams:
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let t of selectedTeams; let i = index">
                    <tr>
                        <td style="width: 50%;">
                            <p>{{ t.teamName }}</p>
                            <p>
                                <span *ngFor="let teamPlayer of t.players; let isLast = last" class="team-player-name">{{ teamPlayer.firstName }} {{ teamPlayer.lastName }}<span *ngIf="!isLast">, </span></span>
                            </p>
                        </td>
                        <td>
                            <div class="field">
                                <input
                                    type="text"
                                    [name]="'score' + i"
                                    required
                                    [(ngModel)]="t.score"
                                    #scoreModel="ngModel"
                                    placeholder=" "
                                />
                                <label></label>
                                <span class="error" *ngIf="scoreModel.invalid && scoreModel.touched">
                                    Score is required
                                </span>
                            </div>
                        </td>
                        <td class="center">
                            <img src="../../../../../assets/noun-x-circle-4815624-FF001C.png" width="25px" (click)="removeTeamFromPost(t)" />
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td colspan="3">
                        <button (click)="postScore(form)" [disabled]="form.invalid">Post</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>

<div class="table-container margin-top-medium">
    <table>
        <thead>
            <tr>
                <th colspan="2">
                    Select teams to post for:
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let t of allTeams">
                <tr *ngIf="!t.isSelected">
                    <td>
                        <p>{{ t.teamName }}</p>
                        <p>
                            <span *ngFor="let teamPlayer of t.players; let isLast = last" class="team-player-name">{{ teamPlayer.firstName }} {{ teamPlayer.lastName }}<span *ngIf="!isLast">, </span></span>
                        </p>
                    </td>
                    <td>
                        <button (click)="selectTeamToPost(t)">
                        Select
                        </button>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
